import { useEffect, useRef, useState } from "react";
import { Camera } from "lucide-react";

/**
 * On every click/tap, render a subtle camera icon at the cursor that
 * fades up and out. Pointer-events: none so it never blocks UI.
 * Disabled on touch-primary (coarse pointer) devices for perf.
 */
export default function ClickCameraEffect() {
  const [pings, setPings] = useState([]);
  const idRef = useRef(0);

  useEffect(() => {
    // Skip on touch/mobile — feels laggy and wastes cycles
    if (typeof window !== "undefined" && window.matchMedia?.("(pointer: coarse)").matches) {
      return;
    }

    const handler = (e) => {
      const tag = (e.target?.tagName || "").toLowerCase();
      if (tag === "input" || tag === "textarea" || tag === "select") return;

      const x = e.clientX;
      const y = e.clientY;
      if (x == null || y == null) return;
      const id = ++idRef.current;
      setPings((p) => [...p, { id, x, y }]);
      setTimeout(() => {
        setPings((p) => p.filter((it) => it.id !== id));
      }, 900);
    };
    window.addEventListener("click", handler, { passive: true });
    return () => {
      window.removeEventListener("click", handler);
    };
  }, []);

  return (
    <div
      className="fixed inset-0 pointer-events-none"
      style={{ zIndex: 9999 }}
      data-testid="click-camera-overlay"
      aria-hidden="true"
    >
      {pings.map((p) => (
        <span
          key={p.id}
          className="rgu-click-camera"
          style={{ left: p.x, top: p.y }}
        >
          <Camera className="w-5 h-5 text-[#0A192F]" strokeWidth={1.8} />
        </span>
      ))}
    </div>
  );
}
